module.exports = __webpack_public_path__ + "img/receipt-2.196dd81a.svg";